import { WebGLAtlasData, WebGLStaticAtlasBuilder } from "./webgl_static_atlas_bulder.js";
import { ImgID } from "../../../../image_loader/img_id.js";
import { ImagesHolder } from "../../../../image_loader/images_holder.js";

export class Vfx2DGlobalAtlas
{
  private static readonly ENABLE_LOGGING: boolean = false;

  private static atlas_data: WebGLAtlasData<ImgID> | null = null;

  public static init(
    resources: ImgID[],
    max_width: number,
    padding: number = 2
  ): void
  {
    if ( this.atlas_data )
      return;

    const list = resources.map( id => ( {
      id,
      image: ImagesHolder.getImage( id )!
    } ) );

    try
    {
      this.atlas_data = WebGLStaticAtlasBuilder.buildAtlasData( list, {
        max_width,
        max_height: max_width,
        power_of_two: true,
        padding
      } );
    }
    catch ( err )
    {
      throw new Error(
        `[Vfx2DGlobalAtlas] Atlas overflow! Current VFX_2D_ATLAS_SIZE (${max_width}x${max_width} px) is too small. ` +
        `Details: ${( err as Error ).message}`
      );
    }

    if ( this.ENABLE_LOGGING )
      this.logAtlasStats( max_width );
  }

  public static logAtlasStats( _max_size?: number ): void
  {
    if ( !this.atlas_data )
      return;

    let sprites_area = 0;
    for ( const sprite of this.atlas_data.sprites.values() )
      sprites_area += sprite.w * sprite.h;

    const canvas_area      = this.atlas_data.width * this.atlas_data.height;
    const free_area        = canvas_area - sprites_area;
    const free_percent     = ( ( free_area / canvas_area ) * 100 ).toFixed( 1 );
    const used_percent     = ( ( sprites_area / canvas_area ) * 100 ).toFixed( 1 );
    const memory_mb        = ( ( canvas_area * 4 ) / ( 1024 * 1024 ) ).toFixed( 1 );

    console.log(
      `[Vfx2DGlobalAtlas] Atlas compiled (${this.atlas_data.width}x${this.atlas_data.height} px, ${memory_mb} MB):\n` +
      `  • Sprites: ${this.atlas_data.sprites.size} pcs (${sprites_area.toLocaleString()} px², ${used_percent}% used)\n` +
      `  • Free Space: ${free_area.toLocaleString()} px² (${free_percent}% free)`
    );
  }

  public static getAtlasData(): WebGLAtlasData<ImgID>
  {
    if ( !this.atlas_data )
      throw new Error( "[Vfx2DGlobalAtlas] Not initialized. Call init() first." );

    return this.atlas_data;
  }

  public static dispose(): void
  {
    this.atlas_data = null;
  }
}
